export default "__VITE_ASSET__578fd14a__"